const footToMeterConversion = 0.3048;
const inchToMeterConversion = 0.0254;

export function meterToFootFloor(value: number) {
    return Math.floor(value / footToMeterConversion)
}
export function meterToInchRounded(value: number) {
    return Math.round(value / inchToMeterConversion);
}

export function meterToInchWithExtractedFoot(value: number, extractedFoot: number) {
    const remainingM = value - extractedFoot * footToMeterConversion;
    const inches = meterToInchRounded(remainingM);
    if (inches === 12) {
        return 11;
    }
    else {
        return inches;
    }
}

export function meterToFootAndInch(value: number) {
    const foot = meterToFootFloor(value);
    const inch = meterToInchWithExtractedFoot(value, foot);

    return {
        foot,
        inch
    }
}